var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-gram-icon",on:{"mouseenter":function($event){_vm.tooltipVisible = true},"mouseleave":function($event){_vm.tooltipVisible = false}}},[_c('icon-gram',{staticClass:"ui-gram-icon__svg"}),_vm._v(" "),(_vm.tooltipVisible)?_c('ui-tooltip',{attrs:{"value":"GRAM","position":"top"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }